/* tslint:disable:no-empty-interface */
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IMobizHttpService, ParameterValueType, SerializableObjectList } from '../../common-react/core';
import { Inject, Injectable, InjectionToken } from '../../common-react/injection';

import { ShipmentDeliveryService } from '../data/shipment-delivery-service.do';
import { ShipmentServiceBracket } from '../data/shipment-service-bracket.do';
import { PosturinnApiEndpointConfiguration } from '../other/api-endpoint-configuration.interface';
import { PosturinnServerApi } from '../other/posturinn-server-api.enum';
import { ShipmentType } from '../other/shipment-type.enum';

export interface IShipmentServiceBracketParams extends Record<string, ParameterValueType> {
  senderPostalCode: string;
  recipientPostalCode: string;
  recipientCountryCode: string;
}

/** @deprecated use IShipmentServiceBracketParams */
export interface IServiceBracketParams extends  IShipmentServiceBracketParams {
}

export interface IShipmentDeliveryServiceParams extends IShipmentServiceBracketParams {
  weight: number;
  length: number;
  width: number;
  height: number;
  type: ShipmentType;
}

/** @deprecated use IShipmentDeliveryServiceParams */
export interface IGetShipmentServiceParams extends  IShipmentDeliveryServiceParams {
}

export interface IRegisterShipmentService {
  /** returns the available Services Brackets based on the selected Recipient address */
  getServiceBracketList(params: IShipmentServiceBracketParams): Observable<ShipmentServiceBracket[]>;

  getDeliveryService(params: IShipmentDeliveryServiceParams): Observable<ShipmentDeliveryService>;
}

export const IRegisterShipmentService = new InjectionToken<IRegisterShipmentService>('IRegisterShipmentService');

@Injectable()
export class RegisterShipmentService implements IRegisterShipmentService {
  constructor(
    @Inject(IMobizHttpService) private httpService: IMobizHttpService,
  ) {}

  public getServiceBracketList(params: IShipmentServiceBracketParams): Observable<ShipmentServiceBracket[]> {
    const config: PosturinnApiEndpointConfiguration = {
      serverApi: PosturinnServerApi.ShipmentDeliveryServiceBrackets,
      queryParameters: params,
    };

    const list: SerializableObjectList<ShipmentServiceBracket> = new SerializableObjectList(ShipmentServiceBracket);

    return this.httpService.get(list, config).pipe(
      map((response: SerializableObjectList<ShipmentServiceBracket>): ShipmentServiceBracket[] => {
        return response.items ? response.items : [];
      }),
    );
  }

  public getDeliveryService(params: IShipmentDeliveryServiceParams): Observable<ShipmentDeliveryService> {
    const config: PosturinnApiEndpointConfiguration = {
      serverApi: PosturinnServerApi.ShipmentSingleDeliveryService,
      queryParameters: params,
    };

    return this.httpService.get(new ShipmentDeliveryService(), config);
  }
}
